import React from 'react'
import { PopoverFilter, PopoverTypeVisualization } from '~/components/shared'
import { EMedicalViews, MedicalViewsType } from '~/interfaces'
import { message } from '~/services'

interface MedicalViewSelectorProps {
  selectedMedicalView: MedicalViewsType
  isActive?: boolean
}

const medicalViewIconNames = {
  [EMedicalViews.GENERAL]: 'dataset',
  [EMedicalViews.RADIOLOGY]: 'ribCage',
  [EMedicalViews.LABORATORY]: 'science',
  [EMedicalViews.MATERNAL_INFANT]: 'pregnantWomanAndNewborn',
  [EMedicalViews.ONCOLOGY]: 'oncology'
}

export const MedicalViewSelector = ({ selectedMedicalView, isActive }: MedicalViewSelectorProps): JSX.Element => {
  const iconName = medicalViewIconNames[selectedMedicalView]
  return (
    <PopoverFilter
      tooltipDescription={message('healthProcedures.medical_views')}
      selectedOption={selectedMedicalView}
      iconName={iconName}
      active={isActive}
      svgFilled
    >
      <PopoverTypeVisualization selectedOption={selectedMedicalView} />
    </PopoverFilter>
  )
}
